const DEFAULT_THEME = {
  cream: "#FAF7F2",
  brown: "#8B6F5E",
  gold: "#D4A853",
  dark: "#2C2416",
  white: "#FFFFFF",
  muted: "#F0EDE6",
  border: "#E8E3DA",
  danger: "#C44D4D",
  success: "#6B8E7B",
  textMuted: "#8E8B82",
  fontHeading: "'Red Hat Display', sans-serif",
  fontBody: "'Red Hat Text', sans-serif",
};

export function applyShopConfig(shop) {
  if (!shop) return;

  if (shop.name) {
    document.title = shop.name;
  }

  if (shop.favicon) {
    const link =
      document.querySelector("link[rel='icon']") ||
      document.querySelector("link[rel='shortcut icon']");
    if (link) {
      link.href = shop.favicon;
    }
  }

  const theme = { ...DEFAULT_THEME, ...shop.theme };

  const root = document.documentElement;
  root.style.setProperty("--tws-cream", theme.cream);
  root.style.setProperty("--tws-brown", theme.brown);
  root.style.setProperty("--tws-gold", theme.gold);
  root.style.setProperty("--tws-dark", theme.dark);
  root.style.setProperty("--tws-white", theme.white);
  root.style.setProperty("--tws-muted", theme.muted);
  root.style.setProperty("--tws-border", theme.border);
  root.style.setProperty("--tws-danger", theme.danger);
  root.style.setProperty("--tws-success", theme.success);
  root.style.setProperty("--tws-text-muted", theme.textMuted);
  root.style.setProperty("--tws-font-heading", theme.fontHeading);
  root.style.setProperty("--tws-font-body", theme.fontBody);
}
